export default __webpack_public_path__ + "static/media/category_color.243b4af3.svg";